export const socialsData = {
    github: 'https://github.com/Altafreza',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/md-altaf-raja',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://altafcse.blogspot.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}